import React, { FC, useMemo } from 'react';
import { isNil } from 'lodash';
import moment from 'moment';
// Import UI Components
import { Icon, Tag } from '@geneui/components';
// Import Context
import { useVersionHistoryContext } from './context';
// Import Hooks
import { usePartnerDateFormats } from 'hooks';
// Import Styles
import styles from './versionHistory.module.scss';
// Import Types
import { VersionHistoryLabelProps } from './types';

export const VersionHistorySelectedVersionLabel: FC<VersionHistoryLabelProps> = ({ objectId, objectTypeId }) => {
    const { partnerDateTimeFormat } = usePartnerDateFormats();
    const { selectedHistoryVersion, selectedObjectDetails, setSelectedHistoryVersion, setSelectedObjectDetails } =
        useVersionHistoryContext();

    const isUnderOtherObjectHistoryContext = useMemo(() => {
        if (isNil(selectedObjectDetails)) {
            return false;
        }

        return selectedObjectDetails.objectId !== +objectId || selectedObjectDetails.objectTypeId !== +objectTypeId;
    }, [objectId, objectTypeId, selectedObjectDetails]);

    const clearSelectedVersion = () => {
        if (isUnderOtherObjectHistoryContext) {
            return;
        }

        setSelectedHistoryVersion(null);
        setSelectedObjectDetails(null);
    };

    if (!selectedHistoryVersion) {
        return null;
    }

    return (
        <div className={styles.selectedVersion}>
            <Tag
                name={`${moment.utc(selectedHistoryVersion.PeriodStart).format(partnerDateTimeFormat)} - ${
                    selectedHistoryVersion.ModifiedByName
                }`}
                appearance="minimal"
                cornerRadius="smooth-radius"
                cursor="unset"
                icons={
                    isUnderOtherObjectHistoryContext ? null : (
                        <Icon type={'bc-icon-clear'} onClick={clearSelectedVersion} />
                    )
                }
            />
        </div>
    );
};
